// Components/AllNotification.jsx
import React from "react";
import {
    Box,
    Paper,
    Typography,
    Avatar,
    Stack,
    Divider,
} from "@mui/material";
// import GroupIcon from "@mui/icons-material/Groups";
import { MdGroup } from "react-icons/md";

const AllNotification = ({ articles = [] }) => {
    return (
        <Stack spacing={2}>
            {articles.map((item) => (
                <Paper
                    key={item.id}
                    elevation={3}
                    sx={{
                        p: 2,
                        borderRadius: 3,
                        backgroundColor: "#f9f9f9",
                        "&:hover": {
                            backgroundColor: "#eef7ee",
                        },
                    }}
                >
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ bgcolor: "#4caf50" }}>
                            <MdGroup />
                        </Avatar>

                        <Box flexGrow={1}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {item.user} <Typography component="span" fontWeight="regular">{item.action}</Typography>{" "}
                                <Typography component="span" fontWeight="bold" color="primary.main">{item.group}</Typography>
                            </Typography>

                            {item.comment && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mt={1}
                                    fontStyle="italic"
                                >
                                    “{item.comment}”
                                </Typography>
                            )}

                            <Divider sx={{ my: 1 }} />

                            <Typography variant="caption" color="text.secondary">
                                {item.time}
                            </Typography>
                        </Box>
                    </Stack>
                </Paper>
            ))}
        </Stack>
    );
};

export default AllNotification;
